import http from '@/utils/http'

import Utils from '@/utils/default'
import Call from './call'

const fetchAll = ({
  page = 1,
  userId = null,
  adminId = null,
  offerId = null,
  serviceType = null,
  resultCode = null,
  dateFilter = null,
  from = null,
  to = null,
  scope = 'all'
}) => {
  const params = {
    page,
    user_id: userId,
    admin_id: adminId,
    offer_id: offerId,
    service_type: serviceType,
    result_code: resultCode,
    from,
    to,
    date_filter: dateFilter,
    scope
  }
  return http()
    .get(`/purchases_v2?${Utils.dataToUrlString(params)}`)
}

const fetch = ({ id }) => http()
  .get(`/purchases/${id}`)

const accept = ({ id }) => http()
  .post(`/accept_purchases`, { purchase_id: id })

const finish = ({ id, serviceType, data = {} }) => http()
  .put(`/${serviceType}_services/${id}`, data)
  .then(_ => http().post(`/finish_purchases`, { purchase_id: id }))

const refund = ({ id, reason }) => http()
  .post(`/refunds`, { purchase_id: id, reason })

const totalPrice = (purchase, platform, expert) => {
  if (purchase.offer.service_type !== 'phone') {
    return purchase.price
  }
  if (platform.multi_experts) {
    return (Call.duration(purchase) / 60) * purchase.service.per_minute_price
  } else {
    return 0
  }
}

const creditedPrice = (purchase, expert) => (purchase.gains || [])
  .filter(x => x.admin_id === expert.id)
  .map(x => x.price)[0] || 0

const fees = (purchase, platform, expert) => Math.round(totalPrice(purchase, platform, expert) - creditedPrice(purchase, expert))

const isPending = purchase => !isRefunded(purchase) && !!purchase.payed_at && !purchase.accepted_at

const isInProgress = purchase => !isRefunded(purchase) && !!purchase.accepted_at && !purchase.finished_at

const isFinished = purchase => isRefunded(purchase) || !!purchase.finished_at

const isRefunded = purchase => !!purchase.refunded_at

const isRefundable = purchase => {
  if (purchase.refunded_at) { return false }
  if (!purchase.payed_at) { return false }
  if (purchase.finished_at) { return false }
  return true
}

export default {
  fetchAll,
  fetch,
  accept,
  finish,
  refund,
  totalPrice,
  creditedPrice,
  fees,
  isPending,
  isInProgress,
  isFinished,
  isRefunded,
  isRefundable
}



// WEBPACK FOOTER //
// ./src/api/purchase.js